"use client";

import { env } from "@/env.mjs";
import { useGeo } from "@/i18n/routing";
import Script from "next/script";
import styles from "./VolumentalWidget.module.css";

const VOLUMENTAL_SDK_SRC = "https://js.volumental.com/sdk/v1/volumental.js";

const localeMap: Record<string, string> = {
	en: "en",
	no: "nb",
	da: "da",
	sv: "sv",
	fi: "fi",
	de: "de",
};

export const VolumentalWidget = () => {
	const clientId = env.NEXT_PUBLIC_VOLUMENTAL_CLIENT_ID;
	const { language } = useGeo();

	if (!clientId) return null;

	const locale = localeMap[language] ?? "en";

	return (
		<div className={styles.container}>
			<Script src={VOLUMENTAL_SDK_SRC} strategy="afterInteractive" data-client-id={clientId} />
			<volumental-measurement locale={locale} theme="light" measurement-on-widget="true" />
		</div>
	);
};

type VolumentalAttrs = React.HTMLAttributes<HTMLElement> & {
	subject?: string;
	"scan-id"?: string;
	locale?: string;
	theme?: "light" | "dark" | "auto";
	variant?: "link" | "outline";
	"measurement-on-widget"?: "true" | "false";
};

declare module "react" {
	namespace JSX {
		interface IntrinsicElements {
			"volumental-measurement": VolumentalAttrs;
			"volumental-measurement-embedded": VolumentalAttrs;
		}
	}
}
